import React from "react";
import { Button } from "@mui/material";
import ShopSettings from "./ShopSettings";
import { useLocation, useParams } from "react-router-dom";
import "./flightshopdetails.scss";
import { type } from "../../../../../utils/constants/constants";

const FlightShopSettings = ({ activeStep, handleSubmit }) => {
  const { shopid } = useParams();
  const location = useLocation();
  const { state } = location;

  return (

    <div className="flightshopdetails">
      <h2>Flight Shop Settings</h2>
      <div className="flightshop-settings-height">
        <ShopSettings activeStep={activeStep} />
      </div>
      {activeStep === 2 && (
        <Button type="submit" form="thirdForm" className="secondary_button mt-10" onClick={handleSubmit}>
          {shopid !== "new" &&
            typeof parseInt(shopid) === type?.number &&
            !state?.cloneflightkey
            ? "Update your Flight Shop"
            : shopid !== "new" &&
              typeof parseInt(shopid) === type?.number &&
              state?.cloneflightkey
              ? "Clone your Flight Shop"
              : "Create your Flight Shop"}
        </Button>
      )}
    </div>
  );
};

export default FlightShopSettings;
